import { push } from 'connected-react-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { VIEWS, WINDOW_WIDTH } from '@/constants/ui';
import { TYPES } from '@/constants/users';
import { LeftSideBar } from '@/newContainers';
import { Layouts, NoInternetConnection, Header, ButtonsCollection } from '@/ui-kit';
import Activity from './components';
import './style.sass';
import { PageError } from '..';
import { uiActions } from '../../state/ui';
import { userSelectors } from '../../state/user';
import { useWindowWidth } from '@/utils/hooks';


/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export const ActivityPage = () => {
  const { t } = useTranslation('common');

  const dispatch = useDispatch();
  const currentUser = useSelector(userSelectors.getUserData());
  const history = useHistory();

  const windowWidth = useWindowWidth();

  const allowedViews = Object.keys(VIEWS);
  const view = window.location.pathname.split('/')[2];

  useEffect(() => {
    if (!view) push('/activity/daily-logs/');
    if (currentUser.type !== TYPES.ADMIN && allowedViews?.includes(view)) push('/activity/me/');
    dispatch(uiActions.setAppTitle('Activity - Avanga 2.0'));
  }, []);

  return allowedViews?.includes(view) ? (
    <Layouts.Main rightSideBarStatus={false}>
      <LeftSideBar />
      <div className="main-container page-activity__main-container">
        <NoInternetConnection>
          <Header>
            <h1 className="weight--medium title--xl title-page">{t('Activity')}</h1>
            {view === 'daily-logs' && (
              windowWidth > WINDOW_WIDTH.MEDIUM ? (
                <ButtonsCollection.ButtonBrill
                  onClick={() => history.push('/activity/daily-logs/submit/')}
                  className="button--sm header__control-button--project"
                >
                  {t('Submit Daily Log')}
                </ButtonsCollection.ButtonBrill>
              ) : (
                <ButtonsCollection.ButtonPlus
                  onClick={() => history.push('/activity/daily-logs/submit/')}
                  className="header__control-button--project"
                />
              )
            )}
          </Header>
          <div className="main-container__content page-activity__activity-content">
            <Activity view={view} />
          </div>
        </NoInternetConnection>
      </div>
    </Layouts.Main>
  ) : (
    <PageError />
  );
};
